import { Insurer } from '../insurer/Insurer';
import { User } from '../User';
import { Vehicle } from '../vehicle/Vehicle';
import { IActivityStreams, IVerifiedVehicle } from './IVerifiedVehicle';
import { ICustomer } from '../customer/ICustomer';
import { Company } from '../company/Company';
import { IDocument, IVerifiedVehicleDocument } from '../../resources/interfaces';
import { getVerifiedVehicleDocumentTitleFromType } from '../../utils/miscFunctions';
import { VERIFICATION_EVENT_TYPES } from '../../resources/enums';
import { IVehicle } from '../vehicle/IVehicle';


export class VerifiedVehicle {
  activityStreams: IActivityStreams[]
  applicationNumber: string
  countryId: number
  createdOn: Date | undefined
  customer: ICustomer
  id: number
  insurer: Insurer | undefined
  coverType: string
  staff: User | undefined
  numberOfVehicles: number
  company: Company | undefined
  updatedOn: string
  vehicles: Vehicle[] | undefined
  verified: boolean
  verifiedOn: string
  eventType : VERIFICATION_EVENT_TYPES;
  documents: IDocument[]
  insurerName?: string;
  customerName?: string;
  customerPhone?: string;


  constructor(Imodel: IVerifiedVehicle) {
    this.applicationNumber = Imodel.applicationNumber;
    this.customer = Imodel.customer;
    this.countryId = Imodel.countryId;
    this.createdOn = Imodel.createdOn ? new Date(Imodel.createdOn) : undefined;
    this.id = Imodel.id;
    this.insurer = Imodel.insurer ? new Insurer(Imodel.insurer) : undefined;
    this.coverType = Imodel.coverType;
    this.staff = Imodel.staff ? new User(Imodel.staff) : undefined;
    this.numberOfVehicles = Imodel.numberOfVehicles;
    this.company = Imodel.company ? new Company(Imodel.company) : undefined;
    this.updatedOn = Imodel.updatedOn;
    this.vehicles = Imodel.vehicles ? Imodel.vehicles?.map((vehicle: IVehicle) => new Vehicle(vehicle)) : undefined;
    this.verified = Imodel.verified;
    this.verifiedOn = Imodel.verifiedOn;
    this.activityStreams = Imodel.activityStreams;
    this.eventType = Imodel.eventType;
    this.documents = Imodel.customer?.documents?.map((document: IDocument) => ({
      id: document.id,
      title: getVerifiedVehicleDocumentTitleFromType(document.docType),
      docType: document.docType,
      docUrl: document.docUrl || document.docURL
    }));
    this.insurerName = Imodel.insurerName;
    this.customerName = Imodel.customerName;
    this.customerPhone = Imodel.customerPhone;
  }
}